import React from 'react'
import { any } from 'prop-types'
import BaseTooltip from '../../../components/BaseTooltip'
import { Badge } from '@mui/material'

const AutorTooltip = ({ title, ...rest }) => {
  const Tool = () => {
    if (title.length > 1) {
      return (
        <BaseTooltip
          style={{
            width: '100%',
            paddingRight: '35px',
            minWidth: '100px',
            display: 'flex',
            justfyContent: 'start'
          }}
          title={<Title />}
          light
          {...rest}
        >
          <Badge
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'start'
            }}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            badgeContent={'+' + (title.length - 1)}
            color="secondary"
          >
            <div>{title[0].autor.nome}</div>
          </Badge>
        </BaseTooltip>
      )
    } else {
      return <div>{title[0].autor.nome}</div>
    }
  }

  const Title = () => {
    const arr = []
    for (let c = 0; c < title.length; c++) {
      if (c > 0) {
        arr.push(title[c])
      }
    }
    return arr.map((item, index) => {
      return (
        <div key={index}>
          {item.autor.nome}
          <br />
        </div>
      )
    })
  }

  return <Tool title={title} />
}

export default AutorTooltip

AutorTooltip.propTypes = {
  children: any,
  title: any
}
